export function SupportPage(): JSX.Element {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white rounded-2xl shadow-soft-lg p-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Support</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-700 mb-6 text-lg">
            For support, please contact us at{' '}
            <a
              href="mailto:support@catchagent.ai"
              className="text-primary-600 hover:text-primary-700 underline font-medium"
            >
              support@catchagent.ai
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
